<div class="flex flex-column align-self-stretch">
  <div class="flex pb-2 font-bold text-lg">
    {{ i18n.i18nLng()['TRANSACTIONDETAILS'] }}
  </div>
  @if (showTransactionError()) {
    <p-message severity="error" styleClass="w-full mb-3 mt-3">{{ transactionErrorMessage() }}</p-message>
  }
  <p-table [value]="tableDataDetails" class="mt-1">
    <ng-template pTemplate="body" let-data>
      <tr>
        <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
            [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
            [colSpan]="data?.titleColspan ? 2 : 1"
            [width]="titleColumnWidth">
          {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
        </td>
        @switch (data?.valueType) {
          @case ('STATE') {
            <td class="flex gap-2 align-items-center">
              @switch (data.value) {
                @case ('successful') {
                  <p-tag [value]="i18n.i18nLng()['SUCCESSFUL']" severity="success" icon="pi pi-check"/>
                }
                @case ('canceled') {
                  <p-tag [value]="i18n.i18nLng()['NOTSUCCESSFUL']" severity="danger" icon="pi pi-exclamation-triangle"/>
                }
                @case ('initialized') {
                  <p-tag [value]="i18n.i18nLng()['INITIALIZED']" severity="secondary" icon="pi pi-plus"/>
                }
                @default {
                  &nbsp;
                }
              }
            </td>
          }
          @case ('ICONANDTEXT') {
            @if (!data?.titleColspan) {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                  [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                  [width]="valueColumnWidth">
                <sps-payment-method-icon-text
                    [text]="data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value"
                    [icon]="data?.valueIcon"
                    [customIcon]="data?.valueCustomIcon">
                </sps-payment-method-icon-text>
              </td>
            }
          }
          @default {
            @if (!data?.titleColspan) {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis flex flex-row gap-3 align-items-center"
                  [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                  style="min-height: 3rem"
                  [width]="valueColumnWidth">
                @switch (data?.valueFormatPipe) {
                  @case ('FULLDATETIME') {
                    {{ data?.value | date : 'dd.MM.yyyy - HH:mm:ss' }}
                  }
                  @default {
                    {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                  }
                }
                <!-- Transaction post-processing buttons (CAPTURE, VOID...) -->
                @if (transactionViewMode === 'TENANT') {
                  @if (data?.valueType === 'POSTPROCESSING') {
                    <!-- capture possible -> show button -->
                    @if (data.flags[0]) {
                      <p-button icon="pi pi-check"
                                size="small"
                                [label]="i18n?.i18nLng()['CAPTUREBUTTON']"
                                [outlined]="true"
                                severity="success"
                                (click)="initCapture()"/>
                    }
                    <!-- void possible -> show button -->
                    @if (data.flags[1]) {
                      <p-button icon="pi pi-times"
                                size="small"
                                [label]="i18n?.i18nLng()['CANCELLATIONBUTTON']"
                                [outlined]="true"
                                severity="danger"
                                (click)="initVoid()"/>
                    }
                  }
                }
              </td>
            }
          }
        }
      </tr>
    </ng-template>
  </p-table>
</div>

@if (tableDataSender) {
  <div class="flex flex-column align-self-stretch mt-6">
    <div class="flex pb-2 font-bold text-lg">
      {{ i18n.i18nLng()['SENDER'] }}
    </div>
    <p-table [value]="tableDataSender" class="mt-1">
      <ng-template pTemplate="body" let-data>
        <tr>
          <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
              [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
              [colSpan]="data?.titleColspan ? 2 : 1"
              [width]="titleColumnWidth">
            {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
          </td>
          @if (!data?.titleColspan) {
            <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                [width]="valueColumnWidth">
              {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}

@if (tableDataRefund && (transactionViewMode === 'TENANT')) {
  <div class="flex flex-column align-self-stretch mt-6">
    <div class="flex pb-2 font-bold text-lg">
      {{ i18n.i18nLng()['REFUND'] }}
    </div>
    <p-table [value]="tableDataRefund" class="mt-1">
      <ng-template pTemplate="body" let-data>
        <tr>
          @switch (data.titleFormatPipe) {
            @case ('AMOUNTCURRENCYLABEL') {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
                  [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
                  [colSpan]="data?.titleColspan ? 2 : 1"
                  [width]="titleColumnWidth">
                {{ i18n.i18nLng()[data.i18nTitleKey] }}&nbsp;{{ data.title | currencyToSymbolPipe }}
              </td>
            }
            @default {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
                  [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
                  [colSpan]="data?.titleColspan ? 2 : 1"
                  [width]="titleColumnWidth">
                {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
              </td>
            }
          }
          @switch (data?.valueType) {
            @case ('REFUNDAMOUNT') {
              @if (!data?.titleColspan) {
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                    [width]="valueColumnWidth">
                  <div class="flex align-items-center gap-2 flex-1">
                    <p-input-number [(ngModel)]="transactionDetailData.refundAmount"
                                    fluid
                                    mode="decimal"
                                    [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                                    [minFractionDigits]="2"
                                    [maxFractionDigits]="2"
                                    (ngModelChange)="checkRefundAmount()">
                    </p-input-number>
                    <p-button icon="pi pi-check"
                              [label]="i18n?.i18nLng()['REFUNDBUTTON']"
                              [outlined]="true" severity="primary"
                              [disabled]="!refundEnabled"
                              (click)="initRefund()"/>
                  </div>
                </td>
              }
            }
            @default {
              @if (!data?.titleColspan) {
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                    [width]="valueColumnWidth">
                  {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                </td>
              }
            }
          }
        </tr>
      </ng-template>
    </p-table>
    @if (showTransactionError() && transactionType === 'REFUND') {
      <p-message severity="error" styleClass="w-full mb-3 mt-3">{{ transactionErrorMessage() }}</p-message>
    }
  </div>
}
@if (tableDataCredit && (transactionViewMode === 'TENANT')) {
  <div class="flex flex-column align-self-stretch mt-6">
    <div class="flex pb-2 font-bold text-lg">
      {{ i18n.i18nLng()['CHARGEBACK'] }}
    </div>
    <p-table [value]="tableDataCredit" class="mt-1">
      <ng-template pTemplate="body" let-data>
        <tr>
          @switch (data.titleFormatPipe) {
            @case ('AMOUNTCURRENCYLABEL') {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
                  [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
                  [colSpan]="data?.titleColspan ? 2 : 1"
                  [width]="titleColumnWidth">
                {{ i18n.i18nLng()[data.i18nTitleKey] }}&nbsp;{{ data.title | currencyToSymbolPipe }}
              </td>
            }
            @default {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
                  [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
                  [colSpan]="data?.titleColspan ? 2 : 1"
                  [width]="titleColumnWidth">
                {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
              </td>
            }
          }
          @switch (data?.valueType) {
            @case ('CREDITAMOUNT') {
              @if (!data?.titleColspan) {
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                    [width]="valueColumnWidth">
                  <div class="flex align-items-center gap-2 flex-1">
                    <p-input-number [(ngModel)]="transactionDetailData.creditAmount"
                                    fluid
                                    mode="decimal"
                                    [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                                    [minFractionDigits]="2"
                                    [maxFractionDigits]="2"
                                    (ngModelChange)="checkCreditAmount()">
                    </p-input-number>
                    <p-button icon="pi pi-check"
                              [label]="i18n?.i18nLng()['CREDITBUTTON']"
                              [outlined]="true" severity="primary"
                              [disabled]="!creditEnabled"
                              (click)="initChargeback()"/>
                  </div>
                </td>
              }
            }
            @default {
              @if (!data?.titleColspan) {
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                    [width]="valueColumnWidth">
                  {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                </td>
              }
            }
          }
        </tr>
      </ng-template>
    </p-table>
    @if (showTransactionError() && transactionType === 'CREDIT') {
      <p-message severity="error" styleClass="w-full mb-3 mt-3">{{ transactionErrorMessage() }}</p-message>
    }
  </div>
}


@if (tableDataHistory) {
  <div class="flex flex-column align-self-stretch mt-6">
    <div class="flex pb-2 font-bold text-lg">
      {{ i18n.i18nLng()['HISTORY'] }}
    </div>
    <p-table [value]="tableDataHistory"
             class="mt-1"
             selectionMode="single"
             (onRowSelect)="historyTransactionSelected($event)">
      <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
        <tr [pSelectableRow]="data" [pSelectableRowIndex]="rowIndex" [pSelectableRowDisabled]="!data.selectable">
          <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
              [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
              [colSpan]="data?.titleColspan ? 2 : 1"
              [width]="titleColumnWidth">
            {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
          </td>
          @if (!data?.titleColspan) {
            <td class="white-space-normal"
                [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                [width]="valueColumnWidth">
              {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
            </td>
          }
          @if (data?.selectable) {
            <td>
              <i class="pi pi-chevron-right"></i>
            </td>
          } @else {
            <td></td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}
